import React, { useContext, useEffect, useRef, useState } from 'react'
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout'
import { Spinner, Tabs, TabsRef } from 'flowbite-react'
import AirtimePurchase from './AirtimePurchase/AirtimePurchase'
import DataPurchase from './DataPurchase/DataPurchase'
import ElectricityPurchase from './ElectricityPurchase/ElectricityPurchase'
import CableTv from './CableTv/CableTv'
import RequirePin from '../../components/RequirePin/RequirePin'
import { UserContext } from '../../contexts/UserContext'
import CustomModal from '../../components/Modal/CustomModal'
import NotificationPopupModal from '../../components/NotificationPopupModal/NotificationPopupModal'
import showToast from '../../components/CustomToast/toastHelper'
import client from '../../api/client'
import OtpVerificationModal from '../../components/OtpVerificationModal/OtpVerificationModal'

const BillPayments = () => {
    const [activeTab, setActiveTab] = useState<number>(0)
    const { userDetails } = useContext(UserContext) ?? {};
    const [openPinCreationModal, setOpenPinCreationModal] = useState(false);
    const [type, setType] = useState<'intro' | 'pinCreationMessage'>('intro');
    const [hasPin, setHasPin] = useState<boolean>(false)
    const [loading, setLoading] = useState(false);
    const [openOtpModal, setOpenOtpModal] = useState<boolean>(false);


    useEffect(() => {
        if (userDetails?.user?.pin === null) {
            setHasPin(false)
        }
        else {
            setHasPin(true)
        }
    }, [userDetails]);

    const handleSendOtp = async() => {
        try {
            setLoading(true)
            const response = await client.post('/subsidiary/dashboard/pin/reset/send-otp', null);
            const message = response?.data?.message;
            showToast(message, "success")
        } catch (err: any) {
    
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                const message = err?.response?.data?.message;
                showToast(message, "error")
            }
        }
        finally{
            setLoading(false)
        }
    }

    const handleCallToAction = () => {
        
            handleSendOtp()
          setOpenPinCreationModal(false)
          setOpenOtpModal(true)
        
    };

    const triggerPinSetup = () => {
        if (!hasPin) {
            setOpenPinCreationModal(true);
            return false; // Stop purchase action
        }
        return true; // Allow purchase action
    };


    const tabsRef = useRef<TabsRef>(null);

    useEffect(() => {
        const storedTabIndex = localStorage.getItem('activeTab');

        if (storedTabIndex !== null) {
            setActiveTab(Number(storedTabIndex));
        }
    }, [activeTab]);

    const handleTabChange = (index: number) => {
        setActiveTab(index);
        localStorage.setItem('activeTab', index.toString());
    };
    return (
        <PrivateLayout>
            <div className='px-6 py-6'>
                <div>
                    <p className='text-xl font-semibold'>Bills Payment</p>
                </div>
                <hr />
                <div className='my-6 w-full'>
                    <Tabs
                        style="underline"
                        className='w-full shadow-none'
                        onActiveTabChange={(activeTab) => handleTabChange(activeTab)}
                        theme={{
                            tablist: {
                                tabitem: {
                                    base: 'flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:ring-0  focus:outline-none rounded-t-lg border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600',
                                },
                            },
                        }}
                    >
                        <Tabs.Item title="Airtime" onClick={() => tabsRef.current?.setActiveTab(0)} active={activeTab === 0}>
                            {/* <RequirePin> */}
                            <AirtimePurchase hasPin={hasPin} triggerPinSetup={triggerPinSetup} />
                            {/* </RequirePin> */}
                        </Tabs.Item>
                        <Tabs.Item title="Internet Data" onClick={() => tabsRef.current?.setActiveTab(1)} active={activeTab === 1}>
                            <DataPurchase hasPin={hasPin} triggerPinSetup={triggerPinSetup} />
                        </Tabs.Item>
                        <Tabs.Item title="Electricity" onClick={() => tabsRef.current?.setActiveTab(2)} active={activeTab === 2}>
                            <ElectricityPurchase hasPin={hasPin} triggerPinSetup={triggerPinSetup}/>
                        </Tabs.Item>
                        <Tabs.Item title="Cable TV" onClick={() => tabsRef.current?.setActiveTab(3)} active={activeTab === 3}>
                            <CableTv hasPin={hasPin} triggerPinSetup={triggerPinSetup}/>
                        </Tabs.Item>

                    </Tabs>
                </div>
            </div>
            <CustomModal
                title=""
                size="md"
                show={openPinCreationModal}
                dismissible
                icon=""
                onClose={() => setOpenPinCreationModal(false)}
            >
                <NotificationPopupModal
                    type={type}
                    close={() => setOpenPinCreationModal(false)}
                    action={()=>handleCallToAction()}
                    message={
                        type === 'intro'
                            ? 'You need to create a PIN to carry out transactions'
                            : 'A verification code will be sent to your email'
                    }
                    buttonText={
                        // type === 'intro'
                        //     ? 'Create PIN'
                        //     : loading
                        //         ? <Spinner />
                        //         : 'Send Code'
                        'Create Pin'
                    }
                />
            </CustomModal>
            <CustomModal title='' size='md' show={openOtpModal} icon='' onClose={() => setOpenOtpModal(false)} dismissible>
                <OtpVerificationModal closeAllModals={() => { setOpenOtpModal(false) }} close={() => setOpenOtpModal(false)} />
            </CustomModal>
        </PrivateLayout>
    )
}

export default BillPayments
